(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["celebracion-nieve"] && !Shopify.designMode) return;
  try {
    // Abre la escena de nieve tras un alta en la lista. Sin este JS el dialogo
  // no se abre nunca, y el alta se confirma igual en el propio formulario.
  (function () {
    var MARCA = 'nyxus-lista-enviada';
    // Cuanto vale la marca que deja formulario-espera al enviar: lo que tarda
    // de sobra una recarga. Una marca vieja es un alta que volvio con error.
    var VIGENCIA = 120000;

    function recienEnviada() {
      try {
        var cuando = +sessionStorage.getItem(MARCA);
        sessionStorage.removeItem(MARCA);
        return cuando > 0 && Date.now() - cuando < VIGENCIA;
      } catch (e) {
        return false;
      }
    }

    function hayWebgl2() {
      try {
        return !!document.createElement('canvas').getContext('webgl2');
      } catch (e) {
        return false;
      }
    }

    // La escena viva, si la hay. Se para siempre antes de arrancar otra: el
    // evento close del dialogo llega en una tarea aparte, y al reabrir rapido
    // la escena nueva arrancaba antes de que la vieja soltara la GPU.
    var actual = null;
    function soltar() {
      if (actual) actual.parar();
      actual = null;
    }

    function cargar(dialogo) {
      var escena = dialogo.querySelector('[data-nieve-escena]');
      soltar();
      // Al reabrir, que vuelva a aparecer con el fundido y no de golpe
      escena.removeAttribute('data-lista');

      function arrancar() {
        if (!dialogo.open || !window.NyxusNieve) return;
        actual = window.NyxusNieve.iniciar(dialogo, {
          alEstarLista: function () { escena.setAttribute('data-lista', ''); }
        });
      }

      if (window.NyxusNieve) {
        arrancar();
        return;
      }
      var script = document.createElement('script');
      script.src = dialogo.getAttribute('data-nieve-js');
      script.onload = arrancar;
      document.head.appendChild(script);
    }

    // Atajo para ver la escena sin apuntarse. Solo fuera del tema publicado
    // (el enlace de vista previa o el editor): en la web real no existe.
    function vistaPrevia() {
      var tema = window.Shopify && window.Shopify.theme;
      return location.hash === '#nieve' && !!tema && !!tema.role && tema.role !== 'main';
    }

    function puedeAbrirse() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      return hayWebgl2();
    }

    function abrir(dialogo) {
      if (dialogo.open || !puedeAbrirse()) return;

      // Al body: el formulario del aviso emergente vive dentro de otro
      // <dialog>, y un modal dentro de un dialogo cerrado no se pinta
      document.body.appendChild(dialogo);

      // El aviso emergente se reabre tras la recarga para ensenar el "Estas
      // dentro" que esta escena ya dice; se cierra para no tener dos modales
      var abiertos = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < abiertos.length; i++) abiertos[i].close();

      dialogo.showModal();
      cargar(dialogo);
    }

    function iniciar() {
      // Con la lista y el aviso emergente en la misma pagina hay dos: basta uno
      var dialogo = document.querySelector('[data-nieve]');
      if (!dialogo || typeof dialogo.showModal !== 'function') return;

      var volver = document.querySelectorAll('[data-nieve-volver]');
      function mostrarVolver() {
        if (!puedeAbrirse()) return;
        for (var i = 0; i < volver.length; i++) volver[i].hidden = false;
      }
      for (var i = 0; i < volver.length; i++) {
        volver[i].addEventListener('click', function () { abrir(dialogo); });
      }

      window.addEventListener('hashchange', function () {
        if (vistaPrevia()) abrir(dialogo);
      });
      dialogo.addEventListener('close', function () {
        // Al cerrar se suelta la GPU: un contexto WebGL vivo en segundo plano
        // es bateria del movil. Si el aviso llega tarde y el dialogo ya se ha
        // vuelto a abrir, la escena viva es la nueva y se queda.
        if (!dialogo.open) soltar();
        mostrarVolver();
        // Al cerrar la vista previa se quita el #nieve, para que volver a
        // escribirlo la abra otra vez
        if (location.hash === '#nieve') history.replaceState(null, '', location.pathname + location.search);
      });

      // Con un alta en la pagina, el boton de volver sale aunque la escena no
      // se abra sola: al recargar ya no hay marca, pero sigue estando dentro
      if (dialogo.hasAttribute('data-nieve-alta')) mostrarVolver();

      // Shopify devuelve todos los formularios de cliente al mismo sitio y el
      // "enviado" es de la pagina entera: sin la marca, un aviso de vuelta a
      // stock en la ficha tambien abriria la nieve.
      var alta = dialogo.hasAttribute('data-nieve-alta') && recienEnviada();
      if (alta || vistaPrevia()) abrir(dialogo);
    }

    // Despues de DOMContentLoaded y no antes: los scripts de las secciones
    // (el aviso emergente) van en otro archivo diferido, y tienen que haber
    // abierto ya su dialogo para que este pueda cerrarlo. El load es por si
    // este archivo llega tarde, cuando DOMContentLoaded ya paso.
    var hecho = false;
    function unaVez() {
      if (hecho) return;
      hecho = true;
      iniciar();
    }
    if (document.readyState === 'complete') {
      unaVez();
    } else {
      document.addEventListener('DOMContentLoaded', unaVez);
      window.addEventListener('load', unaVez);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cuenta-atras"] && !Shopify.designMode) return;
  try {
    // Cuenta atras. Sin dependencias. Sin JS la pagina sigue mostrando los
  // digitos que pinto el servidor: quietos, pero correctos al cargar.
  (function () {
    function iniciar() {
      var contadores = document.querySelectorAll('[data-contador]');

      Array.prototype.forEach.call(contadores, function (raiz) {
        // Dos modos, segun lo que mande el servidor:
        //   data-objetivo  -> fecha entera (los dias estan a la vista, no hay
        //                     nada que ocultar).
        //   data-hora-utc  -> solo el segundo del dia al que cae el drop. Es el
        //                     modo de la pantalla de bloqueo, que es publica:
        //                     asi la fecha no aparece en el codigo fuente.
        var objetivo = null;
        var horaUtc = null;

        if (raiz.hasAttribute('data-hora-utc')) {
          horaUtc = parseInt(raiz.getAttribute('data-hora-utc'), 10);
          if (isNaN(horaUtc)) return;
        } else {
          objetivo = new Date(raiz.getAttribute('data-objetivo')).getTime();
          // Fecha invalida: dejamos los numeros que pinto el servidor y no tocamos nada.
          if (isNaN(objetivo)) return;
        }

        var ultimoDia = raiz.hasAttribute('data-ultimo-dia');
        var digitos = raiz.querySelector('[data-contador-digitos]');
        var vivo = raiz.querySelector('[data-contador-vivo]');
        var campos = {
          dias: raiz.querySelector('[data-dias]'),
          horas: raiz.querySelector('[data-horas]'),
          minutos: raiz.querySelector('[data-minutos]'),
          segundos: raiz.querySelector('[data-segundos]')
        };
        var temporizador = null;
        var anterior = null;

        function pad(n) {
          return n < 10 ? '0' + n : String(n);
        }

        // Escribe solo si el valor cambio: evita repintados innecesarios.
        function poner(nodo, valor) {
          if (nodo && nodo.textContent !== valor) nodo.textContent = valor;
        }

        function activarVivo() {
          if (temporizador) clearInterval(temporizador);
          if (digitos) digitos.hidden = true;
          if (vivo) vivo.hidden = false;
          raiz.setAttribute('data-estado', 'vivo');
        }

        // Siempre desde el reloj real. Nunca restando 1 al valor anterior, que
        // es lo que hace que los contadores se desfasen cuando el navegador
        // congela la pestania en segundo plano.
        function restanteMs() {
          if (objetivo !== null) return objetivo - Date.now();
          // Sin fecha: cuanto falta para la proxima vez que den las 20:30.
          // Date.now() es UTC, y hora-utc tambien, asi que la resta no depende
          // de la zona horaria de quien mira.
          var segAhora = Math.floor(Date.now() / 1000) % 86400;
          return ((horaUtc - segAhora + 86400) % 86400) * 1000;
        }

        function tick() {
          var restante = restanteMs();

          if (objetivo !== null) {
            if (restante <= 0) {
              activarVivo();
              return;
            }
          } else if (ultimoDia && anterior !== null && restante > anterior) {
            // En este modo el contador no sabe que dia es: al llegar a cero da
            // la vuelta a 23:59:59. Esa vuelta solo significa que el drop acaba
            // de empezar si el servidor dijo que caia dentro de las proximas
            // 24 h. Sin esa pista cantaria "en vivo" cada noche a la misma hora.
            activarVivo();
            return;
          }

          var seg = Math.floor(restante / 1000);
          poner(campos.dias, String(Math.floor(seg / 86400)));
          poner(campos.horas, pad(Math.floor((seg % 86400) / 3600)));
          poner(campos.minutos, pad(Math.floor((seg % 3600) / 60)));
          poner(campos.segundos, pad(seg % 60));
          anterior = restante;
        }

        // El drop ya habia empezado cuando se pinto la pagina.
        if (raiz.hasAttribute('data-en-marcha')) {
          activarVivo();
          return;
        }

        tick();
        temporizador = setInterval(tick, 1000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["formulario-espera"] && !Shopify.designMode) return;
  try {
    // Deja una marca al enviar la lista. Sin este JS el alta funciona igual;
  // solo se pierde la escena de nieve que viene despues.
  (function () {
    function iniciar() {
      // Shopify devuelve todos los formularios de cliente al mismo sitio y el
      // "enviado" es de la pagina entera, asi que tras la recarga no hay otra
      // forma de saber que el alta fue de la lista y no del aviso de vuelta a
      // stock de la ficha. La lee celebracion-nieve, con hora para que una
      // marca de un envio que volvio con error caduque sola.
      document.addEventListener('submit', function (e) {
        if (!e.target.classList || !e.target.classList.contains('espera-form')) return;
        try { sessionStorage.setItem('nyxus-lista-enviada', String(Date.now())); } catch (err) {}
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["logo-peonza"] && !Shopify.designMode) return;
  try {
    // Giro con inercia: cada toque suma velocidad y la velocidad vuelve sola a
  // la base. Sin JS el logo gira igual, a ritmo fijo, por la animacion CSS.
  (function () {
    function iniciar() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!window.requestAnimationFrame) return;

      Array.prototype.forEach.call(document.querySelectorAll('[data-peonza]'), function (raiz) {
        var cuerpo = raiz.querySelector('[data-peonza-cuerpo]');
        if (!cuerpo) return;

        var BASE = 360 / 4.3; // grados por segundo: el ritmo del WebP de siempre
        var TOPE = 2600;      // por encima de esto ya es un borron
        var IMPULSO = 900;    // lo que suma cada toque
        var angulo = 0;
        var velocidad = BASE;
        var ultimo = null;
        var quieto = null;
        var fijo = null;

        // El JS toma el relevo de la animacion CSS
        cuerpo.style.animation = 'none';

        function pintar() {
          cuerpo.style.transform = 'rotateY(' + angulo.toFixed(2) + 'deg)';
        }

        function paso(t) {
          if (ultimo === null) ultimo = t;
          // Tope al salto de tiempo: al volver de una pestania en segundo
          // plano no queremos una vuelta entera de golpe
          var dt = Math.min((t - ultimo) / 1000, 0.05);
          ultimo = t;
          if (fijo === null) {
            // Frena hacia la base con una constante de ~1,4 s: arranca fuerte
            // y se calma despacio, que es lo que hace una peonza de verdad
            velocidad += (BASE - velocidad) * (1 - Math.exp(-dt / 1.4));
            angulo = (angulo + velocidad * dt) % 360;
            pintar();
          }
          requestAnimationFrame(paso);
        }

        function impulso(e) {
          if (e.type === 'pointerdown' && e.button !== 0) return;
          velocidad = Math.min(velocidad + IMPULSO, TOPE);
          raiz.classList.add('peonza--impulsada');
          clearTimeout(quieto);
          quieto = setTimeout(function () { raiz.classList.remove('peonza--impulsada'); }, 250);
        }

        raiz.addEventListener('pointerdown', impulso);

        // Congelar en un angulo (editor, pruebas): detail = grados, o null para soltar
        raiz.addEventListener('peonza:fijar', function (e) {
          fijo = (e.detail === null || e.detail === undefined) ? null : +e.detail;
          if (fijo !== null) { angulo = fijo % 360; pintar(); }
        });

        requestAnimationFrame(paso);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["secretos"] && !Shopify.designMode) return;
  try {
    // Los cinco secretos de la pantalla de bloqueo.
  //
  // Sin JavaScript no hay juego, y no pasa nada: la pantalla sigue captando
  // emails exactamente igual. Ningun secreto es requisito para nada de la
  // pagina; el punto final se queda de punto y el tablero, de adorno.
  (function () {
    var TOTAL = 5;
    var CLAVE = 'nyxus-secretos';

    function iniciar() {
      var raiz = document.querySelector('[data-secretos]');
      if (!raiz) return;

      // En el editor de temas se puede jugar para ver como queda, pero no se
      // guarda: si no, Igor terminaria de maquetar con los cinco marcados y
      // sin forma de volver a verlo apagado.
      var persistir = !(window.Shopify && window.Shopify.designMode);

      var casillas = raiz.querySelectorAll('[data-casilla]');
      var aviso = raiz.querySelector('[data-secretos-aviso]');
      var velo = raiz.querySelector('[data-secretos-velo]');
      var punto = document.querySelector('[data-secretos-punto]');
      var pase = raiz.querySelector('[data-pase]');
      var suave = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ---- Estado ---- */

      // Cinco caracteres, uno por secreto. Guardado entero y no por partes
      // para que una escritura a medias no deje el tablero en un estado raro.
      function leer() {
        if (!persistir) return '00000';
        try {
          var v = localStorage.getItem(CLAVE);
          if (typeof v === 'string' && v.length === TOTAL && /^[01]+$/.test(v)) return v;
        } catch (e) {}
        return '00000';
      }

      function guardar(v) {
        if (!persistir) return;
        // Bloqueado (ventana privada, cookies rechazadas) el juego sigue
        // funcionando dentro de la visita: solo no se acuerda manana.
        try { localStorage.setItem(CLAVE, v); } catch (e) {}
      }

      var estado = leer();

      function tiene(i) { return estado.charAt(i) === '1'; }

      function cuantos() {
        var n = 0;
        for (var i = 0; i < TOTAL; i++) { if (tiene(i)) n++; }
        return n;
      }

      function pintar() {
        for (var i = 0; i < casillas.length; i++) {
          var n = +casillas[i].getAttribute('data-casilla');
          if (tiene(n)) {
            casillas[i].setAttribute('data-encendida', '');
          } else {
            casillas[i].removeAttribute('data-encendida');
          }
        }
        if (punto && cuantos() >= TOTAL) {
          punto.setAttribute('data-vivo', '');
          punto.removeAttribute('aria-hidden');
          punto.removeAttribute('tabindex');
          punto.setAttribute('aria-label', pleno);
        }
      }

      var borrarAviso = null;
      var pleno = raiz.getAttribute('data-pleno') || '';
      var cerca = aviso ? (aviso.getAttribute('data-cerca') || '') : '';

      // Por nodos y no por innerHTML: los dos textos salen de ajustes del
      // personalizador, y montar HTML con texto que escribe otro es una
      // costumbre que solo hace falta que salga mal una vez.
      function anunciar(cifra, cola) {
        if (!aviso) return;
        aviso.textContent = '';
        var fuerte = document.createElement('b');
        fuerte.textContent = cifra;
        aviso.appendChild(fuerte);
        if (cola) {
          var resto = document.createElement('span');
          resto.textContent = ' ' + cola;
          aviso.appendChild(resto);
        }
        aviso.hidden = false;
        clearTimeout(borrarAviso);
        borrarAviso = setTimeout(function () { aviso.hidden = true; }, 4200);
      }

      function desbloquear(i) {
        if (tiene(i)) return;
        estado = estado.substring(0, i) + '1' + estado.substring(i + 1);
        guardar(estado);
        pintar();
        var n = cuantos();
        if (n >= TOTAL) {
          anunciar(pleno || n + '/' + TOTAL, '');
        } else {
          anunciar(n + '/' + TOTAL, cerca);
        }
      }

      pintar();

      /* ---- 1. La peonza: veinte impulsos ---- */

      // Se cuentan aqui y no en el snippet del logo porque aquel JS se apaga
      // entero con "reducir movimiento": contarlos alli dejaria sin secreto a
      // quien lo tenga activado.
      var peonza = document.querySelector('[data-peonza]');
      if (peonza) {
        peonza.classList.add('secretos-brillo');
        var golpes = 0;
        var ultimo = 0;

        peonza.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          var ahora = Date.now();
          // Una racha, no un total: veinte toques sueltos repartidos por la
          // visita no deberian desbloquear nada sin querer.
          if (ahora - ultimo > 2500) golpes = 0;
          ultimo = ahora;
          golpes++;

          // Sube la luz segun se acelera. Sin este aviso nadie llega a veinte:
          // un secreto que no da senial de que vas por buen camino no se
          // encuentra, se cuenta.
          if (golpes >= 7) peonza.style.setProperty('--brillo', golpes >= 14 ? '1' : '0.55');

          if (golpes >= 20 && !tiene(0)) {
            golpes = 0;
            // De perfil: la N se reduce a una linea y se ve que es plana.
            // El evento es la API publica del snippet; la clase es el respaldo
            // para quien no tiene ese JS corriendo (con "reducir movimiento"
            // la peonza no tiene transform en linea que pise al de la clase).
            peonza.classList.add('secretos-perfil');
            peonza.dispatchEvent(new CustomEvent('peonza:fijar', { detail: 90 }));
            setTimeout(function () {
              peonza.classList.remove('secretos-perfil');
              peonza.style.removeProperty('--brillo');
              peonza.dispatchEvent(new CustomEvent('peonza:fijar', { detail: null }));
            }, 1200);
            desbloquear(0);
          }
        });
      }

      /* ---- 2. El minuto en punto ---- */

      var contador = document.querySelector('[data-contador]');
      var segundos = contador && contador.querySelector('[data-segundos]');
      if (contador && segundos) {
        contador.classList.add('secretos-tocable');
        contador.addEventListener('pointerdown', function () {
          // Reacciona siempre, acierte o no: eso invita a insistir sin decir
          // cuando hay que tocar.
          if (!suave) {
            segundos.classList.remove('secretos-chispa');
            // Forzar reflow para poder repetir la animacion en toques seguidos
            void segundos.offsetWidth;
            segundos.classList.add('secretos-chispa');
          }
          if ((segundos.textContent || '').trim() === '00') desbloquear(1);
        });
      }

      /* ---- 3. La letra pequenia ---- */

      var letra = document.querySelector('[data-secreto-letra]');
      if (letra) {
        letra.addEventListener('click', function () { desbloquear(2); });
      }

      /* ---- 4. El eclipse: quieto cinco segundos sobre el logo ---- */

      var marca = peonza || document.querySelector('.espera__marca');
      if (marca && velo) {
        marca.classList.add('secretos-brillo');
        var QUIETO = 5000;
        var MARGEN = 12;
        var cuenta = null;
        var desde = null;

        function parar() {
          clearTimeout(cuenta);
          cuenta = null;
          desde = null;
        }

        function esperar(x, y) {
          desde = { x: x, y: y };
          clearTimeout(cuenta);
          cuenta = setTimeout(eclipsar, QUIETO);
        }

        function eclipsar() {
          parar();
          document.documentElement.classList.add('nyxus-eclipse');
          marca.classList.add('secretos__faro');
          setTimeout(function () {
            document.documentElement.classList.remove('nyxus-eclipse');
            marca.classList.remove('secretos__faro');
          }, 2600);
          desbloquear(3);
        }

        marca.addEventListener('pointerdown', function (e) {
          esperar(e.clientX, e.clientY);
        });

        marca.addEventListener('pointermove', function (e) {
          if (e.pointerType === 'mouse') {
            // Con raton el reloj corre por estar encima, y cada movimiento
            // real lo reinicia: "quieto" es quieto de verdad.
            if (!desde || Math.abs(e.clientX - desde.x) > 2 || Math.abs(e.clientY - desde.y) > 2) {
              esperar(e.clientX, e.clientY);
            }
            return;
          }
          // Con el dedo basta con no arrastrarlo
          if (desde && (Math.abs(e.clientX - desde.x) > MARGEN || Math.abs(e.clientY - desde.y) > MARGEN)) parar();
        });

        marca.addEventListener('pointerup', parar);
        marca.addEventListener('pointercancel', parar);
        marca.addEventListener('pointerleave', parar);
      }

      /* ---- 5. La palabra en el campo de la contrasenia ---- */

      // #password-input es el campo real de storefront_password, dentro de
      // "Tengo contrasenia" (sections/password.liquid). No lo renderiza este
      // snippet: se busca en la pagina como se hace con la peonza o el
      // contador, que tampoco son de aqui.
      //
      // Se escucha "input" y no el envio del formulario: en cuanto el valor
      // coincide se desbloquea sin que la contrasenia de verdad llegue a
      // Shopify, asi que nunca se ve el error de "contrasenia incorrecta"
      // por escribir la palabra del secreto.
      var campoAcceso = document.querySelector('#password-input');
      if (campoAcceso) {
        campoAcceso.addEventListener('input', function () {
          if (campoAcceso.value.trim().toLowerCase() !== 'secreto') return;
          // Se vacia el campo: si el visitante pulsa Entrar despues de
          // encontrar el secreto, que no intente un inicio de sesion con
          // "secreto" como si fuera su contrasenia real.
          campoAcceso.value = '';
          campoAcceso.blur();
          desbloquear(4);
        });
      }

      /* ---- El pase ---- */

      if (punto && pase && typeof pase.showModal === 'function') {
        punto.addEventListener('click', function () {
          // El circulo se abre desde donde esta el punto, no desde el centro
          var caja = punto.getBoundingClientRect();
          pase.style.setProperty('--x', (caja.left + caja.width / 2) + 'px');
          pase.style.setProperty('--y', (caja.top + caja.height / 2) + 'px');
          pase.showModal();
        });

        var cerrar = pase.querySelector('[data-pase-cerrar]');
        if (cerrar) cerrar.addEventListener('click', function () { pase.close(); });

        var enviar = pase.querySelector('[data-pase-enviar]');
        var textoBoton = pase.querySelector('[data-pase-boton-texto]');
        if (enviar) {
          enviar.addEventListener('click', function () {
            var mensaje = raiz.getAttribute('data-mensaje') || '';
            var usuario = raiz.getAttribute('data-ig') || '';

            function abrir() {
              // ig.me/m/ es el enlace oficial que abre el chat directo. Sin
              // usuario, al menos no dejamos el boton muerto.
              var url = usuario ? 'https://ig.me/m/' + usuario : 'https://www.instagram.com/';
              window.open(url, '_blank', 'noopener');
            }

            // Instagram no deja rellenar un mensaje desde la URL: no existe
            // ese parametro. Lo mas cerca que se puede estar es dejarlo
            // copiado para que solo haya que pegar.
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(mensaje).then(function () {
                if (textoBoton) textoBoton.textContent = enviar.getAttribute('data-copiado') || textoBoton.textContent;
                abrir();
              }, abrir);
            } else {
              abrir();
            }
          });
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tarjeta-producto"] && !Shopify.designMode) return;
  try {
    /* Sin este script el carril tactil de las tarjetas en marco se sigue
     deslizando; solo faltan los puntos que dicen en que foto se esta. */
  (function () {
    function iniciar() {
      var tarjetas = document.querySelectorAll('.tarjeta--marco.tarjeta--con-segunda');
      Array.prototype.forEach.call(tarjetas, function (tarjeta) {
        var carril = tarjeta.querySelector('.tarjeta__media');
        if (!carril) return;
        tarjeta.setAttribute('data-carril', '0');
        carril.addEventListener(
          'scroll',
          function () {
            var ancho = carril.clientWidth || 1;
            tarjeta.setAttribute('data-carril', Math.round(carril.scrollLeft / ancho) > 0 ? '1' : '0');
          },
          { passive: true }
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
